import { useEffect, useState } from "react";
import DiagnosticsStore from "@/features/diagnostics/store/diagnostics-store.ts";
import { CONFIGURATOR_CONSENT_MODE } from "../resources/constants.ts";
import EventQueue from "../store/event-queue.ts";
import type { OneTrustGroupEnum } from "../types";
import { userGaveConsent } from "../utils/one-trust.ts";

function flushQueueIfConsented(eventQueue: EventQueue) {
    if (!userGaveConsent()) return;

    DiagnosticsStore.collectEventLog("info", "Flushing event queue");
    eventQueue.flush();
}

export default function OneTrustListener() {
    const [eventQueue] = useState(() => EventQueue.getInstance());

    useEffect(() => {
        flushQueueIfConsented(eventQueue);

        const onConsentChange = () => flushQueueIfConsented(eventQueue);

        let consentHookRegistered = false;
        const registerConsentHook = () => {
            if (consentHookRegistered) return;
            if (!window.OneTrust?.OnConsentChanged) return;

            window.OneTrust.OnConsentChanged(onConsentChange);
            consentHookRegistered = true;
        };

        registerConsentHook();

        const pollId = window.setInterval(() => {
            registerConsentHook();
            if (consentHookRegistered) window.clearInterval(pollId);
        }, 250);

        const previousOptanonWrapper = window.OptanonWrapper;
        window.OptanonWrapper = () => {
            previousOptanonWrapper?.();
            onConsentChange();
        };

        const onGroupsUpdated = (event: CustomEvent<Array<OneTrustGroupEnum>>) => {
            if (event.detail.includes(CONFIGURATOR_CONSENT_MODE)) {
                flushQueueIfConsented(eventQueue);
            }
        };

        window.addEventListener("OneTrustGroupsUpdated", onGroupsUpdated);

        return () => {
            window.clearInterval(pollId);
            window.OptanonWrapper = previousOptanonWrapper;
            window.removeEventListener("OneTrustGroupsUpdated", onGroupsUpdated);
        };
    }, [eventQueue]);

    return null;
}
